import { Ref, RefCallback } from "react";

export function mergeRefs<T>(...refs: (Ref<T> | undefined)[]): RefCallback<T> {
    return (node) => {
        refs.forEach((ref) => {
            if (!ref) return;
            if (typeof ref === "function") ref(node);
            else {
                ref.current = node;
            }
        });
    };
}
